const Country = () =>
  import(
    /* webpackChunkName: "base-info-geo-country" */ '@/pages/base-info/geo/country/index.vue'
  )
const CreateCountry = () =>
  import(
    /* webpackChunkName: "base-info-geo-country" */ '@/pages/base-info/geo/country/create.vue'
  )
const EditCountry = () =>
  import(
    /* webpackChunkName: "base-info-geo-country" */ '@/pages/base-info/geo/country/edit.vue'
  )

export default {
  path: 'country',
  meta: {
    label: 'country',
    auth: 'country'
  },
  component: {
    name: 'Country',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoGeoCountry',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Country
    },
    {
      name: 'BaseInfoCreateGeoCountry',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateCountry
    },
    {
      name: 'BaseInfoEditGeoCountry',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditCountry,
      props: true
    }
  ]
}
